import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from './messages'
import translate from './translate'

Vue.use(VueI18n)
Vue.mixin(translate)

const locale = 'en-US'

const i18n = new VueI18n({
  locale,
  messages
})

export default i18n
